import React from 'react'
import { useReportInPlaceExpandOptional } from '@components/pages/Reports/shared/ReportInPlaceExpandContext'

type ReportBundleStickyTopWhenExpandedProps = {
  children: React.ReactNode
}

/**
 * When a report table/chart uses “Full view”, sibling sections unmount and the main panel scrolls.
 * Keeps the page header + {@link ReportFilterToolbar} band pinned together at the top of the scroll
 * container so filters stay reachable (only while an expandable section is expanded).
 */
function ReportBundleStickyTopWhenExpanded(
  props: ReportBundleStickyTopWhenExpandedProps,
): React.ReactElement {
  const { children } = props
  const ctx = useReportInPlaceExpandOptional()
  if (ctx?.expandedSectionId == null) {
    return <>{children}</>
  }
  return (
    <div className="report-bundle-sticky-top-when-expanded">{children}</div>
  )
}

export default ReportBundleStickyTopWhenExpanded
